const QUESTIONS = [{
"question1": {
  "question": "Which Pokemon does Ash first encounter?",
  "option1": "Pidgey",
  "option2": "Pikachu",
  "option3": "Charmander",
  "option4": "Mr. Mime",
  "answer": "Pidgey"
},
"question2": {
  "question": "What did Ash trade his Butterfree for?",
  "option1": "Raticate",
  "option2": "Squirtle",
  "option3": "Tauros",
  "option4": "Metapod",
  "answer": "Raticate"
},
"question3": {
  "question": "How is Gary Oak related to Professor Oak?",
  "option1": "Cousin",
  "option2": "Nephew",
  "option3": "Brother",
  "option4": "Grandson",
  "answer": "Grandson"
},
"question4": {
  "question": "How old was Ash when he started his Pokemon journey?",
  "option1": "11 years old",
  "option2": "10 years old",
  "option3": "12 years old",
  "option4": "9 years old",
  "answer": "10 years old"
},
"question5": {
  "question": "Which Pokemon did Ash catch in Gringey City?",
  "option1": "Muk",
  "option2": "Zubat",
  "option3": "Magnemite",
  "option4": "Charizard",
  "answer": "Magnemite"
}
}]

export default QUESTIONS